// Central content + media for WisdomKeepers
export const MEDIA = {
  heroVideo: "https://videos.pexels.com/video-files/3571264/3571264-uhd_3840_2160_30fps.mp4",
  heroVideoAlt: "https://videos.pexels.com/video-files/3129671/3129671-uhd_3840_2160_30fps.mp4",
  heroPoster:
    "https://images.unsplash.com/photo-1476362555312-ab9e108a0b7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  archive:
    "https://images.unsplash.com/photo-1600181982553-ce7d36051c01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  community:
    "https://images.unsplash.com/photo-1724521260101-c13e61992638?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  closing:
    "https://images.unsplash.com/photo-1767779734218-2b028caa216c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  forestPath:
    "https://images.unsplash.com/photo-1544039161-b0c20826c6f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  mist:
    "https://images.unsplash.com/photo-1506452305024-9d3f02d1c9b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  desert:
    "https://images.unsplash.com/photo-1750859876274-7d8b7a4cb1e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroImage:
    "https://images.unsplash.com/photo-1733415647299-3b30a3eab351?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  placeWide:
    "https://images.unsplash.com/photo-1779875442638-c00ef504252b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
};

export const MANIFESTO = [
  "Archives preserve what was. Wisdom stewards what must continue.",
  "Memory is not about celebrating the past. It is about understanding it deeply enough to make wiser decisions for the future.",
  "Every community carries a story. Every landscape remembers. Every generation inherits both achievement and mistake.",
  "Wisdom begins when we have the courage to remember truthfully, learn collectively and steward that knowledge for those who come after us.",
];

export const PRINCIPLES = [
  {
    title: "Stewardship Before Technology",
    body: "Technology should serve communities, never replace them.",
  },
  {
    title: "Community Authority",
    body: "Communities decide how knowledge is governed, protected and shared.",
  },
  {
    title: "Truthful Memory",
    body: "Wisdom grows through honest remembrance, not selective history.",
  },
  {
    title: "Living Knowledge",
    body: "Knowledge grows through practice, relationship and use.",
  },
  {
    title: "Future Generations",
    body: "Every decision should strengthen those who come after us.",
  },
  {
    title: "Connection",
    body: "Wisdom emerges through relationships between people, places and knowledge.",
  },
];

export const BUILDS = [
  "Community knowledge systems",
  "Cultural governance",
  "Oral history",
  "Language",
  "Ecological knowledge",
  "Traditional law",
  "Scientific knowledge",
  "Restoration knowledge",
  "Intergenerational learning",
  "Artificial intelligence that assists rather than replaces human wisdom",
];

export const CULTURAL_SYSTEMS = [
  {
    name: "Governance Frameworks",
    body: "Community-led decision-making structures that define how knowledge is held, protected and shared — long before any system is built.",
  },
  {
    name: "Mukurtu Implementation",
    body: "One tool among many. Configured to honour cultural protocols, not to become the centre of the work.",
  },
  {
    name: "Knowledge Organisation",
    body: "Structuring knowledge around relationships, people and place rather than files and folders.",
  },
  {
    name: "Metadata & Access Protocols",
    body: "Cultural protocols encoded as living permissions — who may see, hear, hold and pass on each piece of knowledge.",
  },
  {
    name: "Training & Long-term Stewardship",
    body: "Building capability within communities so systems remain theirs for generations, not dependent on outsiders.",
  },
  {
    name: "Healthy Country & SeedKeepers Integration",
    body: "Connecting knowledge to caring for Country — planning, restoration and the seeds that carry the future.",
  },
];

export const INITIATIVES = [
  {
    name: "SeedKeepers",
    tag: "Restoration",
    body: "Safeguarding the seeds and the knowledge to grow them again.",
    img: "https://images.pexels.com/photos/15182672/pexels-photo-15182672.jpeg?auto=compress&cs=tinysrgb&w=1400",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    name: "Growing Country",
    tag: "Land",
    body: "Knowledge that guides the renewal of living landscapes.",
    img: "https://images.unsplash.com/photo-1723166916438-f16eaf6ebb31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "",
  },
  {
    name: "Caring for Country",
    tag: "Stewardship",
    body: "Ranger and community practice, held and passed on.",
    img: "https://images.unsplash.com/photo-1748054934450-9421b27b6a38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "",
  },
  {
    name: "Community Knowledge Systems",
    tag: "Governance",
    body: "Sovereign systems designed around relationships, not databases.",
    img: "https://images.unsplash.com/photo-1761666520005-3ffcf13e74c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-2",
  },
  {
    name: "Language Revitalisation",
    tag: "Language",
    body: "Voices returning to Country and to the next generation.",
    img: "https://images.unsplash.com/photo-1584000838091-bafabb72860d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "",
  },
  {
    name: "StoryKeepers",
    tag: "Oral History",
    body: "Stories held safely, shared on community terms.",
    img: "https://images.unsplash.com/photo-1711060266408-2d1f0d49a926?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "",
  },
  {
    name: "Ecological Restoration",
    tag: "Ecology",
    body: "Traditional and scientific knowledge, working side by side.",
    img: "https://images.unsplash.com/photo-1611843467160-25afb8df1074?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "",
  },
  {
    name: "Stewardship Intelligence",
    tag: "Practice",
    body: "The capacity to make decisions that strengthen future generations.",
    img: "https://images.unsplash.com/photo-1506452305024-9d3f02d1c9b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-2",
  },
];

export const NETWORK_NODES = [
  { label: "Traditional Owner Groups", x: 24, y: 30 },
  { label: "Museums", x: 62, y: 22 },
  { label: "Universities", x: 80, y: 44 },
  { label: "Families", x: 15, y: 62 },
  { label: "Archives", x: 45, y: 16 },
  { label: "Botanical Gardens", x: 72, y: 70 },
  { label: "Language Centres", x: 33, y: 78 },
  { label: "Community Organisations", x: 54, y: 54 },
  { label: "Restoration Projects", x: 88, y: 26 },
  { label: "Libraries", x: 40, y: 44 },
];

export const PARTNERS = [
  "Traditional Owner organisations",
  "Ranger groups",
  "Indigenous Protected Areas",
  "Museums",
  "Libraries",
  "Archives",
  "Universities",
  "Schools",
  "Researchers",
  "Governments",
  "Philanthropic organisations",
  "Environmental organisations",
  "Communities preserving their own history",
];
